import React, { useState, useRef, useEffect } from 'react'
import cn from 'classnames'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

import { showMaintenance } from '../../../store/asset/actions' 

import { PlusIcon, MaintenanceIcon } from '../Icons'
import MaintenancePlanForm from '../MaintenancePlanForm'
import MaintenancePlans from '../MaintenancePlans'
import MaintenanceUpcoming from '../MaintenanceUpcoming'
import MaintenanceCurrent from '../MaintenanceCurrent'
import MaintenanceRecordsHistory from '../MaintenanceRecordsHistory'

const Maintenance = ({companyId}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [activeTab, setActiveTab] = useState('need_maintenance')

  const maintenancePlanFormRef = useRef(null)

  useEffect(() => {
    const handler = (event) => {
      setActiveTab('history')
    }
    window.addEventListener('maintenance-record-created', handler)
    return () => {
      window.removeEventListener('maintenance-record-created', handler)
    }
  }, [])

  const handleCreatePlan = () => {
    maintenancePlanFormRef.current.open()
  }

  const handleRecordMaintenance = () => {
    dispatch(showMaintenance())
  }

  const handleClickPlan = (plan) => {
    maintenancePlanFormRef.current.open(plan)
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerInfo}>
          <div className={styles.headerTitle}>{t('Maintenance')}</div>
          <div className={styles.headerTotals}>{}</div>
        </div>
        <button type="button" className={styles.button} onClick={handleCreatePlan}>
          <PlusIcon />
          { t('New plan') }
        </button>
        <button type="button" className={styles.button} onClick={handleRecordMaintenance}>
          <MaintenanceIcon />
          { t('Record maintenance') }
        </button>
      </div>
      <div className={styles.tabBar}>
        <div className={cn(styles.tabBarItem, {[styles.active]: activeTab === 'need_maintenance'})} onClick={() => setActiveTab('need_maintenance')}>{t('Needs maintenance')}</div>
        <div className={cn(styles.tabBarItem, {[styles.active]: activeTab === 'upcoming'})} onClick={() => setActiveTab('upcoming')}>{t('Upcoming')}</div>
        <div className={cn(styles.tabBarItem, {[styles.active]: activeTab === 'plans'})} onClick={() => setActiveTab('plans')}>{t('Plans')}</div>
        <div className={cn(styles.tabBarItem, {[styles.active]: activeTab === 'history'})} onClick={() => setActiveTab('history')}>{t('History')}</div>
      </div>
      <div className={styles.tabContent}>
        {
          (tab => {
            switch (tab) {
              case 'need_maintenance':
                return (
                  <MaintenanceCurrent
                    companyId={companyId} />
                )
              case 'upcoming':
                return (
                  <MaintenanceUpcoming
                    companyId={companyId} />
                )
              case 'plans':
                return (
                  <MaintenancePlans
                    companyId={companyId}
                    onClickPlan={handleClickPlan} />
                )
              case 'history':
                return (
                  <MaintenanceRecordsHistory
                    companyId={companyId} />
                )
              default:
                return null;
            }
          })(activeTab)
        }
      </div>
      <MaintenancePlanForm
        ref={maintenancePlanFormRef}
        companyId={companyId} />
    </div>
  )
}

export default Maintenance
